import { withInstall } from '@vuesax-alpha/utils'
import Dialog from './src/dialog.vue'

export const VsDialog = withInstall(Dialog)
export default VsDialog

export * from './src/dialog'
